import { render, staticRenderFns } from "./block-contrast.vue?vue&type=template&id=01c176b6&scoped=true&"
import script from "./block-contrast.vue?vue&type=script&lang=js&"
export * from "./block-contrast.vue?vue&type=script&lang=js&"
import style0 from "./block-contrast.vue?vue&type=style&index=0&id=01c176b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c176b6",
  null
  
)

export default component.exports